import { each } from "lodash";
import { getReCaptchaWidgetId } from "./inputs";

declare const grecaptcha: any;
declare const jQuery: any;
const $ = jQuery;

const ajaxCall: Function = window["iw"].utils.ajaxCall;

export interface SubmissionResult
{
    ok: boolean;
    userErrorMsg?: string;
}

const stopProp = (event) => {
    event.stopPropagation();
};

export function initAddForms(): void
{
    $($ => {
        each(["add-company", "add-event"], (popupId: string) => {
            const $popup = $(`[data-popup="${popupId}"]`);
            if ($popup.length === 0)
            {
                console.error(`Popup '${popupId}' not found`);
                return;
            }
            
            initAddForm($popup, popupId);

            $(`a[href="#${popupId}"]`).on("click", function (event) {
                $popup.trigger("open");
                event.preventDefault();
                return false;
            });
        });
    });
}

function initAddForm($popup, popupId: string): void
{
    const actionName: string = popupId;
    const $wrap = $popup.find(".hs-add-form");
    const $submit = $wrap.find(`[data-submit]`);
    const $successMsg = $wrap.find(`.submission-success-message`);
    const $errorMsg = $wrap.find(`.submission-failed-message`);
    const $inputWraps = $wrap.find(`.popup-input`);
    const $textInputs = $wrap.find(`.popup-input-text :input`).not(`[data-display-only]`);
    const $checkboxInputs = $wrap.find(`.popup-input input[type="checkbox"]`);
    const $captchaWrap = $wrap.find(`.popup-input-recaptcha`);
    const doCaptcha: boolean = ($captchaWrap.length > 0) && ("grecaptcha" in window);
    if (!doCaptcha) {
        console.warn(`captcha missing on add form`);
    }
    let busy = false;
    $wrap.on("submit success error complete", stopProp);
    const gatherValidatedData = () => {
        $inputWraps.removeClass("error");
        const data: any = {};
        let error = false;
        if (doCaptcha)
        {
            const captchaId = getReCaptchaWidgetId($captchaWrap);
            if (captchaId === undefined) {
                console.error(`Failed to get captcha`);
            } else {
                data.captcha = grecaptcha.getResponse(captchaId);
                if (!data.captcha)
                {
                    alert(`Please complete the ReCaptcha`);
                    return undefined;
                }
            }
        }
        $textInputs.each(function () {
            const $inp = $(this);
            const required: boolean = $inp.is('[required]');
            const val = $.trim($inp.val());
            if (required && !val)
            {
                $inp.closest(`.popup-input`).addClass("error");
                error = true;
                return;
            }
            if (val && ($inp.attr("type") === "email") && !val.match(/.\@.+\../))
            {
                $inp.closest(`.popup-input`).addClass("error");
                error = true;
                return;
            }
            const name: string = $inp.attr("name");
            data[name] = val;
        });
        $checkboxInputs.each(function () {
            const $inp = $(this);
            const name: string = $inp.attr("name");
            if (!data[name])
            {
                data[name] = [];
            }
            if ($inp.prop("checked"))
            {
                data[name].push($inp.val());
            }
        });
        if (error)
        {
            alert(`Please make sure you have filled in all inputs correctly.`);
            return undefined;
        }
        return data;
    };

    const submitAddForm = async function (): Promise<void> {
        if (busy)
        {
            return;
        }
        const ajaxData: any = gatherValidatedData();
        $successMsg.removeClass("show");
        $errorMsg.removeClass("show");
        if (!ajaxData)
        {
            // validation error
            return;
        }
        busy = true;
        let result: SubmissionResult;
        $submit.attr("disabled", "disabled").addClass("busy-button");
        $wrap.trigger("submit");
        
        let userErrorMsg: string = `Sorry, there was a problem and your submission did not succeed. Please try again later.`;
        try
        {
            result = await ajaxCall(actionName, ajaxData);
            if (!result || !result.ok)
            {
                console.error(`${popupId} submit error result:`, result);
                if (result && result.userErrorMsg)
                {
                    userErrorMsg = result.userErrorMsg;
                }
                throw new Error(`No result/result.ok in enquiry result obj`);
            }
        }
        catch (error)
        {
            if (error && error.response && error.response.userErrorMsg)
            {
                userErrorMsg = error.response.userErrorMsg;
            }
            $wrap.trigger("error");
            console.error(`${popupId} submit failed`, error);
            $errorMsg.html(userErrorMsg).addClass("show");
            $submit.removeAttr("disabled");
            return;
        }
        finally
        {
            busy = false;
            $wrap.trigger("complete");
            $submit.removeClass("busy-button");
        }

        $successMsg.addClass("show");
        $submit.css( { display: "none" }); // Hide submit button to avoid double-submissions
        $wrap.trigger("success");
        setTimeout(() => {
            $popup.trigger("close");
        }, 5000);
    };
    
    // Submit Button Click
    $submit.off("click").on("click", function (event): false {
        event.stopPropagation();
        event.preventDefault();
        submitAddForm();
        return false;
    });
}

